var publicPath = __webpack_public_path__;
                    module.exports = {
                        symbol: publicPath + 'sprite.svg#power',
                        view: publicPath + 'sprite.svg#view-power',
                        viewBox: '0 0 24 24',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };


//////////////////
// WEBPACK FOOTER
// ./src/svg/power.svg
// module id = 411
// module chunks = 0